    document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".pdp_main_product .thumbSwiper", {
    spaceBetween: 19,
    slidesPerView: 6,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".pdp_main_product .thumbSwiper .swiper-button-next",
      prevEl: ".pdp_main_product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 4,
           spaceBetween: 12,
      }
    }
  });

  var featuredSwiper = new Swiper(".pdp_main_product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".pdp_main_product .featuredSwiper .swiper-button-next",
      prevEl: ".pdp_main_product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});

 $(document).ready(function() {


$(".pdp_main_product .desc_wrapper .read_more").on("click", function() {
  $('.desc1').fadeOut(200, function() {
    $('.desc2').fadeIn(200);
  });
});

$(".pdp_main_product .desc_wrapper .read_less").on("click", function() {
  $('.desc2').fadeOut(200, function() {
    $('.desc1').fadeIn(200);
  });
});



// var freeItemAdded = false;
// var FREE_ITEM_VARIANT = 40645673484375;
// var cart_total = $('.mini-cart-total').attr('cart-total');
// console.log(cart_total); 
// function checkCartTotal() {
//   Shopify.getCart(function (cart) {
//     if (cart.total_price >= 5000 ) {   
//       if (!freeItemAdded) {
//         freeItemAdded = true;   // set flag BEFORE the request to prevent loop
      
//         Shopify.addItem(FREE_ITEM_VARIANT, 1, function (item) {
//           theme.miniCart.updateElements();
//           theme.miniCart.generateCart();
//         });
//       }
//     } else {
   


//       var freeItemInCart = cart.items.some(function (item) {
//         return item.id === FREE_ITEM_VARIANT;
//       });

//       if (freeItemInCart) {
//         Shopify.changeItem(FREE_ITEM_VARIANT, 0, function () {  // qty 0 = remove
//           theme.miniCart.updateElements();
//           theme.miniCart.generateCart();
//         });
//       }

//       freeItemAdded = false;  
//     }
//   });
// }


// checkCartTotal();


// $(document).ajaxSuccess(function (event, xhr, settings) {
//   if (/\/cart\/(add|change|update|clear)(\.js)?/.test(settings.url)) {
//     checkCartTotal();
//   }
// });

});








